import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const xtpTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'TLS Profile',
  key: 'tlsProfile',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['lbId', 'ipAddr', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      lbId: {
        label: 'Xcipio Traffic Plane ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 1,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  1,
                ],
              ],
              errorMessage: 'Must be between 1. Please re-enter.',
            },
          ],
        },
      },
      ipAddr: {
        label: 'AF IP Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 42,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
    },
  },
  xtpOptions: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['ID', 'rdrHeartBeatSecs', 'rdrhBtoClose'],
          ['wtrHeartBeatSecs', 'wtrReconnectSecs', 'smpReportInterval'],
          ['droppedAlmInterval', 'throttleUpdInterval', 'dbSyncWaitTime'],
          ['dbQueryTimeout', 'dbQueryIntvl', 'bwAlmThreshHigh'],
          ['bwAlmThreshLow', 'scdRouteAlgorithm'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      ID: {
        label: 'Xcipio Traffic Plane Option ID',
        type: 'text',
        initial: '',
        readOnly: true,
        validation: {
          validators: [
            {
              type: 'length',
              length: 1,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  1,
                ],
              ],
              errorMessage: 'Must be between 1. Please re-enter.',
            },
          ],
        },
      },
      rdrHeartBeatSecs: {
        label: 'Reader (AF) heart-beat interval',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
          ],
        },
      },
      rdrhBtoClose: {
        label: 'Reader (AF) missed heart-beat count',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
          ],
        },
      },
      wtrHeartBeatSecs: {
        label: 'Writer (CF) heart-beat interval',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
          ],
        },
      },
      wtrReconnectSecs: {
        label: 'Writer (CF) re-connect interval',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
          ],
        },
      },
      smpReportInterval: {
        label: 'Sampler report interval',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
          ],
        },
      },
      droppedAlmInterval: {
        label: 'Dropped Packet alarm interval',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
          ],
        },
      },
      throttleUpdInterval: {
        label: 'Throttle Update interval',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
          ],
        },
      },
      dbSyncWaitTime: {
        label: 'Number of seconds Traffic Manager waits for DB Sync',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
          ],
        },
      },
      dbQueryTimeout: {
        label: 'Time limit of sychronization',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
          ],
        },
      },
      dbQueryIntvl: {
        label: 'Periodic interval for retrying to query',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
          ],
        },
      },
      bwAlmThreshHigh: {
        label: 'Bandwidth Alarm High Threshold %',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  50,
                  100,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            }
          ],
        },
      },
      bwAlmThreshLow: {
        label: 'Bandwidth Alarm Low Threshold %',
        type: 'text',
        initial: '0',
        className: 'xtp-form-bandwidth-alarm-low-threshold',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  50,
                  100,
                ],
              ],
              errorMessage: 'Must be between 1 and 3600. Please re-enter.',
            },
            {
              type: 'lessThanValidator',
              compareToKey: 'bwAlmThreshHigh',
              errorMessage: 'Bandwidth Alarm Low Threshold must be less than Bandwidth Alarm High Threshold.',
            },
          ],
        },
      },
      scdRouteAlgorithm: {
        label: 'Xcipio Traffic Plane',
        type: 'radio',
        initial: 'AUTOCONF',
        inline: true,
        className: 'xtp-form-xcipio-traffic-plane',
        options: [
          {
            label: 'Configure its Route table automatically',
            value: 'AUTOCONF'
          },
          {
            label: 'Synchronize Databases for Multi-Tenant',
            value: 'MULTITENANT'
          }
        ],
        optionsTranslatable: true
      },
    },
  },
};
